/* eslint-disable max-len */
module.exports = {
  // =================== Privacy ===================
  privacy: {
    head: "Privacy Policy",
    datechange: "Date of last changes: 2022-12-30",
    blocks: [
      {
        title: "Introduction",
        href: "#ref1",
        text: `
          <strong>At smartteam.dev, the privacy of our visitors is of extreme importance to us.</strong> 
          This privacy policy document outlines the types of personal information is received and collected by smartteam.dev and how it is used.
        `
      },
      {
        title: "What Personal Information Do we collect",
        href: "#ref2",
        text: `
          The information we gather falls into two categories:<br>
          1) Personally identifiable information, which includes personal information you voluntarily supply when you: make out orders, fill out forms (for example: feedback forms), register on the site and provide your email address or phone number.<br>
          2) Non-personally identifiable information, which includes tracking information collected as you navigate through our sites.
        `
      },
      {
        title: "How do we use Personal Information",
        href: "#ref3",
        text: `
          We need to collect personal information so that we can provide you with the publications or services you have requested, or so that we can carry out specific statutory functions (or both). 
          The particular purpose for which we collect personal information will either be explained when we collect that information, or will be obvious from the context in which it is collected.
        `
      },
      {
        title: "Data Security",
        href: "#ref4",
        text: `
          smartteam.dev will take reasonable steps to ensure that all information we collect, use or disclose is accurate, complete, up-to-date and stored in a secure environment accessed only by authorized persons. 
          However, we give no warranty against third parties hacking into the data or any unauthorized access to the data by anyone.
        `
      },
      {
        title: "Log Files",
        href: "#ref5",
        text: `
          Like many other Web sites, smartteam.dev makes use of log files. 
          The information inside the log files includes internet protocol ( IP ) addresses, type of browser, Internet Service Provider ( ISP ), date/time stamp, referring/exit pages, and number of clicks to analyze trends, administer the site, track user’s movement around the site, and gather demographic information. 
          IP addresses, and other such information are not linked to any information that is personally identifiable.
        `
      },
      {
        title: "Third party websites",
        href: "#ref6",
        text: `
          This website may contain hyperlinks to third party websites. 
          We are not responsible for the content of such websites, or for the manner, in which those websites collect, hold, use, and distribute any personal information you provide. 
          When visiting a third party website from hyperlinks displayed on this website, we encourage you to review the privacy statements of those websites so that you can understand how the personal information you provide will be will collected, held, used and distributed.
        `
      },
      {
        title: "Changes to our Privacy Policy",
        href: "#ref7",
        text: `
          We reserve the right, at our discretion, to update or revise this privacy policy at any time. 
          Changes to this privacy policy will take effect immediately once published on this website. 
          Please check this privacy policy regularly for modifications and updates. 
          If you continue to use this website or if you provide any personal information after we post changes to this privacy policy, this will indicate your acceptance of any such changes.
        `
      },
      {
        title: "Cookies Policy",
        href: "#ref8",
        text: `
          <span class='txt-blue'>IMPORTANT NOTICE: PLEASE READ CAREFULLY BEFORE USING THIS WEBSITE.</span><br>
          This policy explains how cookies are used on this website. 
          The policy may be amended from time to time. 
          When we do, we will let you know by appropriate means such as by posting the revised policy on this page with a new “Last Updated” date. 
          By using this site, you agree to the placement of cookies on your computer in accordance with the terms of this policy. 
          If you do not wish to accept cookies from this site, please either disable cookies or refrain from using this site.
        `
      },
      {
        title: "What are Cookies?",
        href: "#ref9",
        text: `
          A cookie is a text-only string of information that a website transfers to the cookie file of the browser on your computer’s hard disk so that the website can recognize you when you revisit and remember certain information about you. 
          This can include which pages you have visited, choices you have made from menus, any specific information you have entered into forms and the time and date of your visit.
        `
      },
      {
        title: "Types of Cookies",
        href: "#ref10",
        text: `
          <strong>There are two main types of cookies:</strong><br>
          <strong>Session cookies:</strong> these are temporary cookies that expire at the end of a browser session; that is, when you leave the site. Session cookies allow the website to recognize you as you navigate between pages during a single browser session and allow you to use the website most efficiently.<br>
          <strong>Persistent cookies:</strong> in contrast to session cookies, persistent cookies are stored on your equipment between browsing sessions until expiry or deletion. They therefore enable the website to “recognize” you on your return, remember your preferences, and tailor services to you.
        `
      },
      {
        title: "Our use of Cookies",
        href: "#ref11",
        text: `
          We currently use, and may use in the future, the following types of cookies on this website. <strong>We use session cookies to:</strong><br>
          Help us maintain security and verify your details whilst you use the website as you navigate from page to page, which enables you to avoid having to re-enter your details each time you enter a new page.<br>
          <strong>We use persistent cookies to:</strong><br>
          Help us recognize you as a unique user when you return to our website so that you do not have to input your details multiple times as you move between our pages or services.<br>
          Collect and compile anonymous, aggregated information for statistical and evaluation purposes to help us understand how users use the website and help us improve the structure of our website.<br>
          Many cookies are designed to give you optimal usage of the web. 
          For example, we use cookies to enable you to improve your user experience when using our website, e.g. a cookie which recognizes if your browser supports specific technology features. 
          This helps; for example, in enabling web pages to be loaded more quickly when you request the download of a large file. 
          In addition to cookies, which send information to us, we also use cookies, which collect information and send it to third parties. 
          An example of this is Google Analytics. 
          We use Google Analytics to help collect and compile information like the number of visitors to the site, where visitors have come to the site from and the pages they visited. 
          Visit Google’s site for an overview of privacy at Google and information on how to opt out of the Google Analytics cookie. 
          As with first party cookies, you are able to block third party cookies through your browser settings. 
          Some of our cookies may collect and store your personal information, such as your name or email address. 
          We are committed to respecting and protecting your privacy and will ensure that all personal information collected by us is kept and treated in accordance with our privacy policy.
        `
      },
      {
        title: "Refusing Cookies on this Site",
        href: "#ref12",
        text: `
          Most browsers are initially set to accept cookies. 
          However, you have the ability to disable cookies if you wish, generally through changing your Internet software browsing settings. 
          It may also be possible to configure your browser settings to enable acceptance of specific cookies or to notify you each time a new cookie is about to be stored on your computer enabling you to decide whether to accept or reject the cookie. 
          <strong>To manage your use of cookies there are various resources available to you</strong>, for example the “Help” section on your browser may assist you. 
          You can also disable or delete the stored data used by technology similar to cookies, such as Local Shared Objects or Flash cookies, by managing your browser’s “add-on settings” or visiting the website of its manufacturer.
        `
      },
      {
        title: "Additional Information",
        href: "#ref13",
        text: `<strong>If you have any questions about this Privacy Policy, please contact us on mail@smartteam.dev</strong>`
      }
    ]
  }
};
/* eslint-enable max-len */
